import React from 'react';
import Svg from '../Svg';

const IconFramer = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.07615 1.11732C4.23093 0.743642 4.59557 0.5 5.00003 0.5H19C19.5523 0.5 20 0.947715 20 1.5V8.5C20 9.05228 19.5523 9.5 19 9.5H14.4142L19.7071 14.7929C19.9931 15.0789 20.0787 15.509 19.9239 15.8827C19.7691 16.2564 19.4045 16.5 19 16.5H13V22.5C13 22.9045 12.7564 23.2691 12.3827 23.4239C12.009 23.5787 11.5789 23.4931 11.2929 23.2071L4.29292 16.2071C4.10539 16.0196 4.00003 15.7652 4.00003 15.5V8.5C4.00003 7.94772 4.44774 7.5 5.00003 7.5H9.58582L4.29292 2.20711C4.00692 1.92111 3.92137 1.49099 4.07615 1.11732ZM12.4142 7.5H18V2.5H7.41424L12.4142 7.5ZM11.5858 9.5H6.00003V14.5H16.5858L11.5858 9.5ZM11 16.5H7.41424L11 20.0858V16.5Z"
    />
  </Svg>
);

export default IconFramer;
